import {LOAD_LOCATION_SUGGESTIONS_SUCCESS, CLEAR_LOCATION_SUGGESTIONS} from './actions';

export const locationSuggestions = (state = [], action) => {
  switch (action.type) {
    case CLEAR_LOCATION_SUGGESTIONS:
      return [];
    case LOAD_LOCATION_SUGGESTIONS_SUCCESS:
      return action.value.resource;
    default:
      return state;
  }
};
